/**
 * The server's own explanation of a failed request, or `fallback` without one.
 *
 * The backend answers in two shapes: FastAPI's HTTPException sends
 * `{ detail }`, while the app's FinCreatorException handler sends
 * `{ message }` (quota exceeded, duplicate open setup, market data down...).
 * Reading only `detail` hid every reason in the second shape behind a generic
 * "failed" toast.
 *
 * A 422 from the app's validation handler says only "Request validation
 * failed" in `message`; when one of its errors came from a validator of ours
 * (pydantic's `value_error`, e.g. "Could not resolve host 'x'"), that reason
 * is shown instead. Pydantic's own generic errors ("Field required") are not.
 */
export const apiErrorMessage = (error: unknown, fallback: string): string => {
  const data = (
    error as {
      response?: {
        data?: {
          detail?: unknown
          message?: unknown
          details?: { validation_errors?: { type?: unknown; msg?: unknown }[] }
        }
      }
    }
  )?.response?.data
  const ours = (Array.isArray(data?.details?.validation_errors) ? data.details.validation_errors : []).find(
    (e) => e?.type === 'value_error' && typeof e.msg === 'string'
  )
  const reason = typeof ours?.msg === 'string' ? ours.msg.replace(/^Value error, /, '') : undefined
  for (const value of [data?.detail, reason, data?.message]) {
    if (typeof value === 'string' && value.trim()) return value
  }
  return fallback
}
